<template>
  <div class="login">

    <a-form
      :form="form"
      @submit="handleSubmit"
      >

      <a-form-item
        label="E-mail"
      >
        <a-input
          v-decorator="[
            'login_email',
            {
              rules: [{
                type: 'email', message: 'The input is not valid E-mail!',
              }, {
                required: true, message: 'Please enter your email address.',
              }]
            }
          ]"
        />
      </a-form-item>

      <a-form-item
        label="Password"
      >
        <a-input
          v-decorator="[
            'login_password',
            {
              rules: [{
                required: true, message: 'Please enter a password!',
              }],
            }
          ]"
          type="password"
        />
      </a-form-item>

      <a-form-item v-if="feedback">
        <span class="feedback">
          {{ feedback }}
        </span>
      </a-form-item>

      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          style="float: right;"
        >
          Login
        </a-button>
      </a-form-item>

    </a-form>
        
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: "Login",
  data() {
    return {
      form: this.$form.createForm(this),
      feedback: null,
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault();
      this.feedback = null;
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
          firebase.auth().signInWithEmailAndPassword(
            values.login_email, values.login_password)
            .then(cred => {
              console.log("!", cred.user.uid);
              this.$router.push("/app");
            })
            .catch(err => {
              this.feedback = err.message;
            })
        }
      });
    },
  }
}
</script>

<style scoped>

.feedback {
  font-weight: bold;
  color: #faad14;
}

</style>

